import { useFetcher, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Button } from '~/common/components/ui/button';
import { ShoppingCart } from 'lucide-react';
import { cn } from '~/common/utils/styleUtil';
import { Tooltip, TooltipContent, TooltipTrigger } from '~/common/components/ui/tooltip';

export interface UnauthorizedCartButtonProps {
  className?: string;
  size?: 'default' | 'sm' | 'lg';
  redirectPath?: string;
}

export function UnauthorizedCartButton({ className, size, redirectPath }: Readonly<UnauthorizedCartButtonProps>) {
  const fetcher = useFetcher();
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <fetcher.Form method={'POST'} action={'/infra/auth/login'} className={className}>
      <input type="hidden" name="redirectUrl" value={redirectPath ?? location.pathname + location.search} />
      <Tooltip>
        <TooltipTrigger asChild={true}>
          <Button variant={'ghost'} className={cn('w-full', size === 'lg' ? 'h-11' : '')}>
            <ShoppingCart size={24} className="text-secondary" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>{t('Bitte loggen Sie sich ein')}</TooltipContent>
      </Tooltip>
    </fetcher.Form>
  );
}
